import { defineStore } from 'pinia';
import type { GameNavNode } from '@/features/game/game-api';
import { resolveOroMxLobbyTab } from '@/features/game/oro-mx-catalog';
import { isSimulationSession, notifySimulationUnsupported } from '@/shared/simulation/simulation-session';
import { useSessionStore } from '@/stores/session-store';

export const useOroMxShellStore = defineStore('oroMxShell', {
  actions: {
    closeMenu() {
      this.menuOpen = false;
    },
    closeScratch() {
      this.scratchOpen = false;
    },
    closeJackpot() {
      this.jackpotOpen = false;
    },
    closeSearch() {
      this.searchOpen = false;
    },
    openMenu() {
      this.menuOpen = true;
    },
    openScratch() {
      if (isSimulationSession(useSessionStore().player?.accountKind)) {
        notifySimulationUnsupported();
        return;
      }
      this.jackpotOpen = false;
      this.scratchOpen = true;
    },
    openJackpot() {
      if (isSimulationSession(useSessionStore().player?.accountKind)) {
        notifySimulationUnsupported();
        return;
      }
      this.scratchOpen = false;
      this.jackpotOpen = true;
    },
    openSearch() {
      this.searchOpen = true;
    },
    setLobbyTab(id: string) {
      this.lobbyTab = resolveOroMxLobbyTab(id, this.navNodes);
    },
    setNavNodes(nodes: GameNavNode[]) {
      this.navNodes = nodes;
      this.lobbyTab = resolveOroMxLobbyTab(this.lobbyTab, nodes);
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
  state: () => ({
    lobbyTab: 'lobby',
    menuOpen: false,
    navNodes: [] as GameNavNode[],
    scratchOpen: false,
    jackpotOpen: false,
    searchOpen: false,
  }),
});
